export default "__VITE_ASSET__UzZS3awW__"